<template>
  <BlokkliProvider
    v-if="blokkliProps"
    v-slot="{ entity, isEditing }"
    v-bind="blokkliProps"
    :entity="props"
  >
    <header
      class="relative flex h-[402px] w-full items-center justify-center overflow-hidden text-center uppercase text-white md:h-[353px]"
    >
      <div
        v-if="isEditing || mainImage"
        v-blokkli-droppable:field_media_image
        class="pointer-events-none !absolute left-0 top-0 h-full w-full items-stretch"
      >
        <MediaImage
          v-if="entity?.mainImage || mainImage"
          v-bind="entity?.mainImage || mainImage"
          class="relative h-full w-full"
          img-class="object-cover w-full h-full"
          eager
          preload
          :image-style="imageStyle"
        />
      </div>
      <div class="relative max-w-full px-16">
        <div
          v-if="entity?.overline || isEditing"
          v-blokkli-editable:field_overline
          class="mb-8 text-xs/[24px] tracking-[0.96px] md:mb-16 md:text-base md:tracking-[1.28px]"
        >
          {{ entity?.overline || '&nbsp;' }}
        </div>
        <h1
          v-blokkli-editable:title
          class="text-5xl/[56px] md:text-7xl"
          :class="{
            'font-bold': isRebranding,
          }"
        >
          {{ entity?.title || title }}
        </h1>
      </div>
    </header>
    <BlokkliField name="field_paragraphs" :list="paragraphs" />
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import { type NodePageFragment } from '#graphql-operations'

const props = defineProps<{
  overline?: string
  title?: string
  paragraphs?: NodePageFragment['paragraphs']
  mainImage?: NodePageFragment['mainImage']
  blokkliProps?: NodePageFragment['blokkliProps']
}>()

const isRebranding = await useFeatureFlag()

const imageStyle = defineImageStyle({
  type: 'pictures',
  pictures: {
    sm: {
      width: 780,
      height: 432,
    },
    md: {
      width: 1025,
      height: 360,
    },
    lg: {
      width: 1200,
      height: 360,
    },
    xl: {
      width: 1450,
      height: 360,
    },
    xxl: {
      width: 2496,
      height: 432,
    },
  },
})
</script>
